export class NullPurse {
    static async pay(rawtx: string): Promise<string> {
        return rawtx;
    }
}